import { Types } from '@grandvisionhq/graphql';
import { isDefined, getLocalizedString, isNumber } from '@grandvisionhq/utils';
import { createProductTypeName } from '../utils/create-product-type-name.js';
import { getConsolidationFacet } from '../utils/get-consolidation-facet.js';
import { getDiscount } from '../utils/get-discount.js';

const mapGraphProductToListingProduct = (product, intl, priceSegment)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const { locale  } = intl;
    const slug = product.slug;
    const productType = createProductTypeName(product.productType);
    const unmappedMasterVariant = product.variants[0];
    if (!slug || !productType || !product.variants || !unmappedMasterVariant) {
        console.error(`No slug, objectId, productType or variants found for product slug: ${product.slug}`);
        return undefined;
    }
    const masterVariant = mapVariant(product, unmappedMasterVariant, locale, priceSegment);
    if (!masterVariant) {
        console.error('No variants found for product slug: ', product.slug);
        return undefined;
    }
    const otherVariants = product.variants.slice(1).map((variant)=>mapVariant(product, variant, locale, priceSegment)
    ).filter(isDefined);
    const localizedName = getLocalizedString(product.nameAllLocales, locale);
    const isFrameProduct = product.__typename === 'FrameProduct';
    const isOfferedWithPrescriptions = isFrameProduct || product.__typename === 'SunglassesProduct' ? Boolean(product.productTypeDetails.isOfferedWithPrescriptions) : false;
    var ref7;
    const includesLenses = isFrameProduct ? (ref7 = (ref1 = (ref = product.productTypeDetails.offerings) === null || ref === void 0 ? void 0 : ref.find((offering)=>offering.includesLenses
    )) === null || ref1 === void 0 ? void 0 : ref1.includesLenses) !== null && ref7 !== void 0 ? ref7 : undefined : undefined;
    var ref8;
    const totalQuantity = (ref8 = (ref2 = unmappedMasterVariant.inventory) === null || ref2 === void 0 ? void 0 : ref2.totalQuantity) !== null && ref8 !== void 0 ? ref8 : 0;
    return {
        masterVariant,
        objectID: '',
        isOnStock: Boolean(totalQuantity >= 1),
        includedVatAmount: (ref3 = product.taxCategory) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.rate) === null || ref4 === void 0 ? void 0 : ref4.amount,
        offering: {
            includesLenses
        },
        isOfferedWithPrescriptions,
        name: {
            en: product.name,
            localized: localizedName
        },
        ratingsSummary: {
            average: (ref5 = product.ratingsSummary) === null || ref5 === void 0 ? void 0 : ref5.average,
            reviewCount: (ref6 = product.ratingsSummary) === null || ref6 === void 0 ? void 0 : ref6.reviewCount
        },
        productType,
        slug,
        variants: otherVariants
    };
};
const mapVariant = (product, variant, locale, priceSegment)=>{
    var ref37, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30;
    const images = variant.media.images.map((img)=>({
            url: img.url,
            label: img.label || '',
            altTag: '',
            dimensions: {
                w: img.dimensions.w,
                h: img.dimensions.h
            }
        })
    );
    const priceList = variant.priceList.filter((priceListItem)=>priceListItem.priceType === Types.ProductPriceItemType.SINGLE_PURCHASE
    );
    const singlePurchasePricesSegment = priceList.find((price)=>{
        var ref;
        return ((ref = price.priceSegment) === null || ref === void 0 ? void 0 : ref.channelKey) === priceSegment;
    });
    const singlePurchasePricesDefault = priceList.find((price)=>{
        var ref;
        return !((ref = price.priceSegment) === null || ref === void 0 ? void 0 : ref.channelKey);
    });
    const prices = singlePurchasePricesSegment || singlePurchasePricesDefault;
    if (!prices || !prices.originalPrice) {
        console.error('No prices found for product sku: ', variant.sku);
        return undefined;
    }
    const isContactLensVariant = variant.__typename === 'ContactLensVariant';
    const isSolutionVariant = variant.__typename === 'SolutionVariant';
    const isAccessoryVariant = variant.__typename === 'AccessoriesVariant';
    const isSunglassesVariant = variant.__typename === 'SunglassesVariant';
    const isFrameVariant = variant.__typename === 'FrameVariant';
    const isReadyReaderVariant = variant.__typename === 'ReadyReaderVariant';
    const hasTargetGender = isFrameVariant || isAccessoryVariant || isSunglassesVariant;
    const hasMaterial = isContactLensVariant || isAccessoryVariant;
    const getFrameFeature = ()=>{
        if (isFrameVariant) {
            return variant.variantTypeDetails.frameFeatures;
        }
        if (isSunglassesVariant || isReadyReaderVariant) {
            return variant.variantTypeDetails.maybeFrameFeatures;
        }
        return undefined;
    };
    const getBrandModelAndCode = ()=>{
        if (isAccessoryVariant) {
            return {
                model: variant.variantTypeDetails.brandModel,
                code: variant.variantTypeDetails.brandModelCode
            };
        }
        if (isSunglassesVariant || isReadyReaderVariant || isFrameVariant) {
            return {
                model: variant.variantTypeDetails.maybeBrandModel,
                code: variant.variantTypeDetails.maybeBrandModelCode
            };
        }
        return undefined;
    };
    const consolidationFacet = getConsolidationFacet(variant);
    var ref31, ref32, ref33, _material, ref34, _lensType, _lensColor, _packageQuantity, _solutionType, _isExclusiveBrand, _power, ref35, ref36;
    return {
        brand: {
            name: product.brand,
            model: ((ref37 = getBrandModelAndCode()) === null || ref37 === void 0 ? void 0 : ref37.model) || '',
            modelCode: ((ref9 = getBrandModelAndCode()) === null || ref9 === void 0 ? void 0 : ref9.code) || ''
        },
        description: variant.description || '',
        erpId: variant.erpId || '',
        name: variant.displayName,
        sku: variant.sku,
        frame: {
            color: {
                en: (ref10 = getFrameFeature()) === null || ref10 === void 0 ? void 0 : ref10.color.join(', ')
            },
            material: {
                en: (ref31 = (ref11 = getFrameFeature()) === null || ref11 === void 0 ? void 0 : ref11.material) !== null && ref31 !== void 0 ? ref31 : undefined
            },
            shape: {
                en: (ref32 = (ref12 = getFrameFeature()) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.shape) === null || ref13 === void 0 ? void 0 : ref13.displayName) !== null && ref32 !== void 0 ? ref32 : undefined
            },
            type: {
                en: (ref33 = (ref14 = getFrameFeature()) === null || ref14 === void 0 ? void 0 : ref14.type) !== null && ref33 !== void 0 ? ref33 : undefined
            }
        },
        material: hasMaterial ? (_material = variant.variantTypeDetails.material) !== null && _material !== void 0 ? _material : undefined : undefined,
        accessoryType: {
            en: isAccessoryVariant ? (ref34 = (ref15 = variant.variantTypeDetails.accessoryType) === null || ref15 === void 0 ? void 0 : ref15.displayName) !== null && ref34 !== void 0 ? ref34 : undefined : undefined
        },
        accessoryColor: {
            en: isAccessoryVariant ? variant.variantTypeDetails.color.join(', ') : undefined
        },
        lensType: {
            en: isContactLensVariant ? (_lensType = variant.variantTypeDetails.lensType) !== null && _lensType !== void 0 ? _lensType : undefined : undefined
        },
        faceShape: isFrameVariant || isSunglassesVariant ? {
            en: variant.variantTypeDetails.faceShape.map((val)=>val.shape
            ).join(', ')
        } : undefined,
        lensColor: isContactLensVariant ? (_lensColor = variant.variantTypeDetails.lensColor) !== null && _lensColor !== void 0 ? _lensColor : undefined : undefined,
        priceIncludedAmount: undefined,
        packageQuantity: isContactLensVariant ? (_packageQuantity = variant.variantTypeDetails.packageQuantity) !== null && _packageQuantity !== void 0 ? _packageQuantity : undefined : undefined,
        solutionType: isSolutionVariant ? (_solutionType = variant.variantTypeDetails.solutionType) !== null && _solutionType !== void 0 ? _solutionType : undefined : undefined,
        isExclusiveBrand: product.__typename === 'FrameProduct' || product.__typename === 'SunglassesProduct' ? (_isExclusiveBrand = product.productTypeDetails.isExclusiveBrand) !== null && _isExclusiveBrand !== void 0 ? _isExclusiveBrand : undefined : undefined,
        gender: {
            en: hasTargetGender ? variant.variantTypeDetails.targetGender.join(', ') : undefined
        },
        tag: ((ref16 = variant.tags) === null || ref16 === void 0 ? void 0 : ref16[0]) ? {
            key: variant.tags[0].key,
            value: variant.tags[0].value
        } : undefined,
        images,
        power: isReadyReaderVariant ? (_power = variant.variantTypeDetails.power) !== null && _power !== void 0 ? _power : undefined : undefined,
        pricing: {
            // Best price is returned as a cent amount, but the other prices are floats, therefore, we transform it into a decimal
            bestPrice: isNumber(variant.bestPrice) ? variant.bestPrice / 100 : undefined,
            price: {
                isCentAmount: false,
                originalPrice: prices.originalPrice.amount,
                currencyCode: prices.originalPrice.currencyCode,
                discount: ((ref17 = prices.discountedPrice) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.price) === null || ref18 === void 0 ? void 0 : ref18.amount) ? {
                    price: (ref19 = prices.discountedPrice.price) === null || ref19 === void 0 ? void 0 : ref19.amount,
                    badge: getDiscount(locale, (ref20 = prices.discountedPrice) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.price) === null || ref21 === void 0 ? void 0 : ref21.currencyCode, (ref35 = (ref22 = prices.discountedPrice) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.discountInformation) === null || ref23 === void 0 ? void 0 : ref23.type) !== null && ref35 !== void 0 ? ref35 : undefined, (ref36 = (ref24 = prices.discountedPrice) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.discountInformation) === null || ref25 === void 0 ? void 0 : ref25.value) !== null && ref36 !== void 0 ? ref36 : undefined),
                    description: (ref26 = prices.discountedPrice.discountInformation) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.description) === null || ref27 === void 0 ? void 0 : (ref28 = ref27[0]) === null || ref28 === void 0 ? void 0 : ref28.value
                } : undefined
            },
            pricePerUnit: {
                amount: (ref29 = prices.pricePerUnit) === null || ref29 === void 0 ? void 0 : ref29.amount,
                currencyCode: (ref30 = prices.pricePerUnit) === null || ref30 === void 0 ? void 0 : ref30.currencyCode
            }
        },
        isInsuranceReimbursable: isFrameVariant && variant.variantTypeDetails.isInsuranceReimbursable,
        replacementFrequency: product.__typename === 'ContactLensProduct' ? getLocalizedString(product.productTypeDetails.replacementFrequencyAllLocales, locale) : undefined,
        contactLensCareType: isSolutionVariant ? variant.variantTypeDetails.contactLensCareType || undefined : undefined,
        packageOption: isSolutionVariant ? `${variant.variantTypeDetails.volume}${variant.variantTypeDetails.volumeUnit}` : undefined,
        consolidationFacet
    };
};

export { mapGraphProductToListingProduct, mapVariant };
//# sourceMappingURL=map-graph-product-to-listing-product.js.map
